export const ACKNOWLEDGEMENTS = {
  PROMO_POOL_TUTORIAL_LABEL_MANAGERS: 'promo_pool_tutorial_label_managers',
  DJ_MIX_INTRO_CONFIRM: 'dj_mix_intro_confirmation'
};
